export default commomImport => [{
  path: `all-order`,
  name: 'AllOrder',
  meta: {
    title: 'store.allOrder',
    noCache: true
  },
  //  全部订单
  component: commomImport('order-manager/all-order')
}];
